import React from "react";
import { Link } from "react-router-dom";
import { POSTS, readingTime } from "../lib/blogContent";

export default function BlogIndexPage() {
  React.useEffect(() => {
    document.title = "Insights · LeadRiver";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <main className="max-w-4xl mx-auto px-6 pt-32 pb-24">
        <p className="kicker">Insights</p>
        <h1 className="h-section text-[clamp(2rem,4.2vw,3.4rem)] mt-5 max-w-2xl">
          Operational truth for trade contractors.
        </h1>
        <p className="font-serif-body text-[#4A4A4A] mt-5 max-w-xl text-[1.05rem] leading-relaxed">
          No AI hype. Just the systems problems that decide who wins a storm
          season — written by the team building the fix.
        </p>

        <div className="mt-14 space-y-8">
          {POSTS.map((p) => (
            <Link
              key={p.slug}
              to={`/blog/${p.slug}`}
              data-testid={`blog-card-${p.slug}`}
              className="block bg-white border border-[#E5E0D8] hover:border-[#0B3D5C] transition-colors overflow-hidden group"
            >
              <div className="grid sm:grid-cols-[280px_1fr]">
                <img
                  src={p.image}
                  alt={p.imageAlt}
                  className="w-full h-48 sm:h-full object-cover"
                />
                <div className="p-7">
                  <p className="font-mono-spec text-[11px] text-[#8A8378]">
                    {p.dateLabel} · {readingTime(p)} min read
                  </p>
                  <h2 className="font-sans-tight font-extrabold text-[1.35rem] leading-snug tracking-tight mt-2 group-hover:text-[#0B3D5C]">
                    {p.title}
                  </h2>
                  <p className="font-serif-body text-[14.5px] text-[#4A4A4A] mt-3 leading-relaxed">
                    {p.metaDescription}
                  </p>
                  <p className="font-sans-tight text-[13px] font-bold text-[#E07B3A] mt-4">
                    Read the post →
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
